import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c89ae60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CountdownTimer" }
const _hoisted_2 = { class: "time" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "segmentation" }, ":", -1))
const _hoisted_4 = { class: "time" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "segmentation" }, ":", -1))
const _hoisted_6 = { class: "time" }

import { ref, onMounted, onUnmounted, watch } from 'vue'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  props: {
    endTime: { type: [String, Number, Date], required: true },
    onFinish: { type: Function, required: false }
  },
  setup(__props: any) {

const props = __props as {
  endTime: string | number | Date // 支持字符串、时间戳或Date对象,
  onFinish?: () => void // 可选的回调函数，当倒计时结束时调用
}


const hours = ref('00')
const minutes = ref('00')
const seconds = ref('00')
const timer = ref<NodeJS.Timeout | null>(null)

const updateCountdown = () => {
  const now = dayjs()
  const end = dayjs(props.endTime)
  const diff = end.diff(now, 'second')
  if (diff <= 0) {
    hours.value = '00'
    minutes.value = '00'
    seconds.value = '00'
    if (timer.value) clearInterval(timer.value)
    props.onFinish?.()
    return
  }
  const h = Math.floor(diff / 3600)
  const m = Math.floor((diff % 3600) / 60)
  const s = diff % 60
  hours.value = String(h).padStart(2, '0')
  minutes.value = String(m).padStart(2, '0')
  seconds.value = String(s).padStart(2, '0')
}

onMounted(() => {
  updateCountdown()
  timer.value = setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  if (timer.value) clearInterval(timer.value)
})

watch(() => props.endTime, () => {
  updateCountdown()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {
      hours: hours.value,
      minutes: minutes.value,
      seconds: seconds.value
    }, () => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(hours.value), 1),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(minutes.value), 1),
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(seconds.value), 1)
    ])
  ]))
}
}

})